export const VERTICALS = {
    lifemind: {
        label: "LifeMind",
        tagline: "Personal finance, home, family — the stuff of your day-to-day life.",
        accentColor: "#f59e0b",
    },
    workmind: {
        label: "WorkMind",
        tagline: "Career, commerce, and the tools you use to get things done.",
        accentColor: "#3B5BDB",
    },
    arenamind: {
        label: "ArenaMind",
        tagline: "Games and head-to-head fun.",
        accentColor: "#ec4899",
    },
};
// Rendered in this order regardless of the catalog's own ordering.
export const VERTICAL_ORDER = ["lifemind", "workmind", "arenamind"];
// Site cards must link to the same environment the landing page itself is running in — a
// visitor on any environment (prod, preprod, ui.dev/ui.nonprod) clicking "Hearthbook" should
// land on that same environment's hearthbook, not jump to prod.
export function siteCardHostname(slug) {
    return `${window.location.hostname}/${slug}`;
}
